<template>
  <div class="container decentered single-table-layout">
    <div class="layout-content">
      <webon-table
        v-if="displayTable"
        :module-name="moduleName"
        v-bind="webonTableProps"
        v-on="webonTableProps.events"
        :ref="refCustom"
        :table-id="tableId"
        :shrink-table="shrinkTable"
      >
        <div slot="toolbar">
          <slot name="webon-table-toolbar"></slot>
        </div>
      </webon-table>
    </div>
  </div>
</template>

<script>
import WebonTable from "@/components/global/webon/webon-table/WebonTable";

export default {
  name: "single-table-layout",
  components: {
    WebonTable,
  },
  props: {
    webonTableProps: {
      type: Object,
    },
    shrinkTable: {
      type: Boolean,
      default: false,
    },
    moduleName: {
      type: String,
    },
    displayTable: {
      type: Boolean,
      default: true,
    },
    refCustom: {
      type: String,
      default: "webonTable",
    },
    tableId: {
      type: String,
      default: "webon-table",
    },
  },
};
</script>

<style lang="scss">
.single-table-layout {
  height: 100%;
  display: flex;
  padding: 0px 20px;

  .layout-content {
    flex-grow: 2;
    height: 100%;
    overflow-y: auto;
  }
}
</style>